import DataReference from './DataReference.js';
import NormalizedDataReference from './NormalizedDataReference.js';
export default function fromDataReferenceProps(reference) {
    let constructed;
    if ('numerator' in reference) {
        constructed = new NormalizedDataReference({
            numerator: new DataReference(reference.numerator),
            denominator: new DataReference(reference.denominator),
        });
    }
    else {
        constructed = new DataReference(reference);
    }
    return constructed;
}
